export default __webpack_public_path__ + "static/media/LoginImg.0a0c2522.svg";